import { z } from "zod";
import { batteryTermsSchema, supplyTermsSchema, supplyHullContextSchema, SUPPLY_IDS, SUPPLY_KINDS } from "@frontier/content/supplies";
import { MAX_CARGO_SLOTS, MAX_CARGO_UNITS } from "@frontier/content/cargo-stacks";
import { STATION_IDS } from "@frontier/content/stations";
import { cargoKindSchema } from "./risk-contracts.js";
import { profileSchema } from "./contracts.js";

export const supplyStationViewSchema = z.strictObject({
  ...supplyHullContextSchema.shape,
  runId: z.uuid(),
  status: z.enum(["docked", "flying"]),
  stationId: z.enum(STATION_IDS).nullable(),
  priceVersion: z.string().min(1).max(100),
  items: z.array(z.strictObject({ supplyId: z.enum(SUPPLY_IDS), kind: z.enum(SUPPLY_KINDS), name: z.string(),
    stock: z.number().int().nonnegative(), loaded: z.number().int().nonnegative(), terms: supplyTermsSchema })).max(9),
  battery: z.strictObject({
    stock: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
    loaded: z.number().int().min(0).max(MAX_CARGO_UNITS),
    terms: batteryTermsSchema,
  }),
  hold: z.strictObject({
    capacity: z.number().int().min(1).max(MAX_CARGO_SLOTS),
    usedSlots: z.number().int().min(0).max(MAX_CARGO_SLOTS),
    cargo: z.array(cargoKindSchema).max(MAX_CARGO_UNITS),
  }),
});
export type SupplyStationView = z.infer<typeof supplyStationViewSchema>;
export const supplyStationResultSchema = z.strictObject({
  profile: profileSchema,
  supplies: supplyStationViewSchema,
});

export const supplyControlsSchema = z.strictObject({
  ...supplyHullContextSchema.shape,
  runId: z.uuid(), lifeSeq: z.number().int().nonnegative(),
  nextItemId: z.string().min(1).max(200).nullable(),
  count: z.number().int().min(0).max(MAX_CARGO_UNITS),
  energy: z.number().finite().nonnegative(),
  cooldownSeconds: z.number().int().nonnegative(),
  pending: z.boolean(),
  items: z.array(z.strictObject({ kind: z.enum(SUPPLY_KINDS), itemId: z.string().nullable(), count: z.number().int().nonnegative(),
    cooldownSeconds: z.number().int().nonnegative(), terms: supplyTermsSchema.nullable() })).max(3),
});
export type SupplyControls = z.infer<typeof supplyControlsSchema>;
export const supplyUseAckSchema = z.strictObject({
  ...supplyHullContextSchema.shape,
  requestId: z.string().min(8).max(100), accepted: z.boolean(),
  code: z.string().min(1).max(100), message: z.string().max(300),
});
export type SupplyUseAck = z.infer<typeof supplyUseAckSchema>;
